import { render } from "./UpdateRoman.vue?vue&type=template&id=38e19042"
import script from "./UpdateRoman.vue?vue&type=script&lang=js"
export * from "./UpdateRoman.vue?vue&type=script&lang=js"

import "./UpdateRoman.vue?vue&type=style&index=0&id=38e19042&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__